import { ProtectionPeriodEnum } from 'src/graphql/schema';

export const protectionPeriodOptions = [
  {
    label: '3 months (default)',
    value: ProtectionPeriodEnum.M_3,
  },
  {
    label: '6 months',
    value: ProtectionPeriodEnum.M_6,
  },
  {
    label: '12 months',
    value: ProtectionPeriodEnum.M_12,
  },
];

export const protectionPeriodOptionsDictionary = {
  [ProtectionPeriodEnum.M_3]: '3 months (default)',
  [ProtectionPeriodEnum.M_6]: '6 months',
  [ProtectionPeriodEnum.M_12]: '12 months',
};
